<sm-table *ngIf="inited" [data]="table">
</sm-table>
